import Vue from 'vue';
import merge from 'lodash/merge';
import psHttp, { generateExceptionRedirector, psAxios } from '@patsnap/common-ps-http';
import { createUniformSetting } from '@patsnap/uniform-setting';
import { HeaderService, SLD, Site } from '@patsnap-utils/biz';
import { prepareTokenBase, resolveHeader, updateTokenBaseRequestHeaders } from '../token-base';
import setWebsiteFont from '../utils/configure-website-font';
import getCommonInit from '../utils/getCommonInit';
import defer from './defer';
import _ from 'lodash';
import { ACCOUNT_SERVICE_URI } from 'library-@/config/apiConfig';
import { initLegalStatus } from 'library-@/components/legal-tag/legal-config';
import { getGlobalConfig } from 'library-@/utils/getGlobalConfig';

const { set, get } = _;

const supports = ['cn', 'en', 'tw', 'jp'];

const DEFAULT_REDIRECT_URL = new Site({ sld: SLD.ACCOUNT, pathname: `user-settings/#/no-permission?from_site=${process.env['VUE_APP_PASSPORT_CLIENT_NAME']}` }).href;

export function startup({ projectName, preset, pageInit, zPREFACE = true, sentry = true, redirect = DEFAULT_REDIRECT_URL, isFreeView = false, forceSetLocale, headerService: _headerService }) {
    return (preset ? prepareTokenBase(preset) : Promise.resolve()).then(() => {
        const headerService = _headerService || new HeaderService();

        return Promise.all([
            headerService.sync({ http: psHttp, uri: ACCOUNT_SERVICE_URI }).then((accountInfo) => {
                const setting = createUniformSetting({
                    verbose: true,
                    axiosInstance: psAxios,
                    /* 特殊 ip 时 或者 free 时，loggedIn 设置为 false */
                    loggedIn: !accountInfo.special_ip && !isFreeView,
                    baseAccountUrl: ACCOUNT_SERVICE_URI,
                    locale: {
                        supports,
                    }
                });
                console.log('setting', setting);

                return setting.locale.getLocale().then(({ default: defaultLocale, user }) => {
                    const locale = forceSetLocale || user || defaultLocale;
                    setWebsiteFont(locale);
                    updateTokenBaseRequestHeaders({ 'X-Site-Lang': locale.toUpperCase() });
                    return [headerService, locale, setting];
                });
            }).then((data) => {
                const [headerService, locale, setting] = data;
                resolveHeader({ headerService, locale, setting });
                return data;
            }),
            pageInit(),
            getCommonInit(),
            initLegalStatus(),
        ]).then((data) => {
            const [[headerService, locale, setting], pageData, commonInitData, legalConfig] = data;
            // FIXME: Step1: CommonInit下沉，featureConfigs字段以及setLastPage逻辑各个项目均有使用，后续移除
            // FIXME: Step1: CommonInit下沉，featureConfigs字段以及setLastPage逻辑各个项目均有使用，后续移除
            // FIXME: Step1: CommonInit下沉，featureConfigs字段以及setLastPage逻辑各个项目均有使用，后续移除
            const globalData = getGlobalConfig(headerService, commonInitData);
            if (zPREFACE) {
                window.zPREFACE = merge({}, window.zPREFACE, pageData, globalData, legalConfig, { accountInfo: get(headerService, 'account._info', {}) });
            }
            /* 兼容遗留代码 */
            fixZpreface(locale);
            /* 延迟加载不需要立即加载的组件 */
            defer(Vue, projectName, headerService.account, { sentry }, locale, isFreeView);
            return [headerService, locale, pageData, globalData, setting, legalConfig];
        }).catch(generateExceptionRedirector(403, redirect));
    }).catch(err => {
        console.log(err);
    });
}

export function fixZpreface(locale) {
    /* 兼容遗留代码 */
    set(window, 'zPREFACE.globalConfig', {
        ...get(window, 'zPREFACE.globalConfig', {}),
        get currentLanguage() {
            console.warn('[Deprecation] 不要从 zPREFACE 获取当前语言');
            return locale;
        }
    });
}
